var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_12624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3471 5.93047H8.06936V1.6527C8.06936 1.36906 7.95669 1.09704 7.75613 0.896485C7.55557 0.695925 7.28355 0.583252 6.99992 0.583252C6.71628 0.583252 6.44427 0.695925 6.24371 0.896485C6.04315 1.09704 5.93047 1.36906 5.93047 1.6527V5.93047H1.6527C1.36906 5.93047 1.09704 6.04315 0.896485 6.24371C0.695925 6.44427 0.583252 6.71628 0.583252 6.99992C0.583252 7.28355 0.695925 7.55557 0.896485 7.75613C1.09704 7.95669 1.36906 8.06936 1.6527 8.06936H5.93047V12.3471C5.93047 12.6308 6.04315 12.9028 6.24371 13.1034C6.44427 13.3039 6.71628 13.4166 6.99992 13.4166C7.28355 13.4166 7.55557 13.3039 7.75613 13.1034C7.95669 12.9028 8.06936 12.6308 8.06936 12.3471V8.06936H12.3471C12.6308 8.06936 12.9028 7.95669 13.1034 7.75613C13.3039 7.55557 13.4166 7.28355 13.4166 6.99992C13.4166 6.71628 13.3039 6.44427 13.1034 6.24371C12.9028 6.04315 12.6308 5.93047 12.3471 5.93047Z",
    fill: "#0076FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_12624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.3beacc0a97b47ed9979c7be2ee3e4350.svg";
export { ForwardRef as ReactComponent };